import { Component, OnInit } from '@angular/core';
import { GridviewComponent } from '../gridview/gridview.component';
import { Router,RouterModule} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';

@Component({
  selector: 'app-request-summary',
  templateUrl: './request-summary.component.html',
  styleUrls: ['./request-summary.component.scss']
})
export class RequestSummaryComponent implements OnInit {
  private gridApi;
  public addnew:Boolean = false;
  private gridColumnApi;
  public context;
  private frameworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  tabToNextCell:any;
  columnDefs = [
    {headerName: 'Request Type', field: 'type' },
    {headerName: 'Requested Date', field: 'date' },
    {headerName: 'Request Status', field: 'status'},
    {headerName: 'Action', field: 'action',cellRenderer:'viewrenderer'}
];

rowData = [];
  constructor(public toastService:ToastrService, public loginService:LoginService, public router:Router) { }

  ngOnInit() {
    this.context = {
      componentParent:this
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellPosition;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
      return;
      } else {
      return nextCell;
      }
      }; 
    this.frameworkComponents = {
      viewrenderer: GridviewComponent
    };
    if(this.loginService.staticData.get('requestsData') !=undefined){
      this.loginService.staticData.delete('requestsData');
    }
    this.load();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  newRequest(){
    this.router.navigate(['requests/create'])
  }
  load(){
    let request = {
      perId: this.loginService.personId
    }
    this.loginService.loadTasks(request).subscribe((data:Array<Object>)=>{
      data.forEach((element)=>{
        let rwData = {
          type:null,
          status:null,
          date:null,
          action:{
            id:null,
            status:null,
            notes:null,
            reason:null,
            month:null
          }
        }
        rwData.date = element['task_start_dt'].split('T')[0].split('-')[1] + '/' + element['task_start_dt'].split('T')[0].split('-')[2] + '/' + element['task_start_dt'].split('T')[0].split('-')[0];
        rwData.action.id = element['id'];
        rwData.action.notes = element['notes'];
        if(element['task_type'] == 'CA' && element['task_status'] == 'CO'){
          rwData.type = 'Appointment request';
          rwData.status = 'Processed';
        }
        else if (element['task_type'] != 'CA' && element['task_status'] == 'CO' && element['authorization'] == 'G'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Approved';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        else if (element['task_type'] == 'CE'  && element['authorization'] == 'G'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Approved';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        //Adding for CE and GD
        else if (element['task_type'] == 'CE'  && element['authorization'] == 'D'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Denied';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        else if (element['task_type'] == 'CG'  && element['authorization'] == 'G'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Approved';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        else if (element['task_type'] == 'CG' && element['authorization'] == 'D'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Denied';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }


        else if (element['task_type'] != 'CA' && element['task_status'] == 'CO' && element['authorization'] == 'D'){
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Denied';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        else if(element['task_type'] == 'CA' && element['task_status'] != 'CO'){
          rwData.type = 'Appointment request';
          rwData.status = 'Submitted';
        }
        else{
          rwData.type = 'Good Cause/Exemption request';
          rwData.status = 'Submitted';
          rwData.action.reason = element['comp_reason'];
          rwData.action.month = element['comp_month'];
        }
        rwData.action.status = rwData.status;
        this.rowData.push(rwData);
        this.gridApi.setRowData(this.rowData);
      });
    },error=>{
      this.toastService.error('Unable to load requests summary','My Requests')
    })
  }
  clickEvent(event){
    if(event.column.colDef.headerName == 'Action' && event.data.defaultAction == 'view'){
      this.loginService.staticData.set('requestsData',event.data);
      this.router.navigate(['requests/create']);
    }
  }
  focus(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell(0, firstCol);
      }
    }
    else{
      return;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/request-summary/request-summary.component.ts